import { useLanguage } from '../../translations';

export const useTranslation = <T>(languages: { en: T; [key: string]: T }): T => {
  const { language } = useLanguage();

  return languages[language] || languages.en;
};
